import { useState } from 'react';
import { ContactInfo } from '../../../models/ContactInfo';
import { useAsyncEffect } from 'use-async-effect';
import { getContactInfo } from '../../../services/getContactInfo';

const useContactInfo = () => {
  const [contactInfo, setContactInfo] = useState<ContactInfo>();
  const [loading, setLoading] = useState(true);

  useAsyncEffect(async () => {
    try {
      const response = await getContactInfo();
      setContactInfo(response);
      setLoading(false);
    } catch (error) {
      throw new Error('hiba az adatok lekérésekor');
    }
  }, []);

  return { contactInfo, loading };
};

export default useContactInfo;
